import React from "react";

type PhotoVideoProps = {
  color?: string, // Cor personalizada para o ícone
  size?: number, // Tamanho do ícone
};

const PhotoVideo: React.FC<PhotoVideoProps> = ({
  color = "#FF5733",
  size = 50,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Ícone de câmera */}
      <rect
        x="6"
        y="18"
        width="28"
        height="20"
        rx="4"
        stroke={color}
        strokeWidth="2"
        fill="#FFD700"
      />
      <circle
        cx="20"
        cy="28"
        r="6"
        stroke={color}
        strokeWidth="2"
        fill="#FFD700"
      />
      <rect x="12" y="10" width="8" height="4" rx="2" fill={color} />

      {/* Ícone de vídeo */}
      <rect
        x="38"
        y="18"
        width="20"
        height="20"
        rx="4"
        stroke={color}
        strokeWidth="2"
        fill="#FF6347"
      />
      <path d="M46 22v8l6-4-6-4z" fill="#FF6347" />

      {/* Ícone de galeria */}
      <rect
        x="6"
        y="42"
        width="52"
        height="16"
        rx="3"
        stroke={color}
        strokeWidth="2"
        fill="#90EE90"
      />
      <circle cx="16" cy="50" r="4" fill={color} />
      <path
        d="M26 54l6-8 5 6 8-10"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
    </svg>
  );
};

export default PhotoVideo;
